import { MONETATE_DETAILS} from './types';
export const monetateDetailsAction = (monetateDetails) => dispatch => {
    console.log('monetateDetails in redux...',monetateDetails);
    dispatch({
        type: MONETATE_DETAILS,
        monetateDetails: monetateDetails
    })

}